import React from "react";
import { IoMdArrowBack } from "react-icons/io";
import { useNavigate } from "react-router-dom";

const termsData = [
  {
    title: "Terms of Service",
    lastUpdated: "July 5, 2024",
  },
  {
    sectionTitle: "Introduction",
    content: `Please read these terms of service carefully. When you use EduBridge Classroom's service...`,
  },
  {
    sectionTitle: "Interpretation and Definitions",
    content: `Capitalised words have meanings defined under the following conditions. These definitions apply whether they appear in singular or plural.`,
    definitions: [
      {
        term: "Account",
        definition:
          "means a unique account created for you to access our service or parts of our service.",
      },
      {
        term: "Application",
        definition:
          "refers to EduBridge Classroom, the software program provided by the Company.",
      },
      {
        term: "Company",
        definition:
          "refers to Embankment Bridge Ltd, 86 - 90 Paul Street, London, England, EC2A 4NE.",
      },
      { term: "Country", definition: "refers to: United Kingdom." },
      {
        term: "Device",
        definition:
          "means any device that can access the Service such as a computer, a mobile phone, or a digital tablet.",
      },
      {
        term: "Personal Data",
        definition:
          "is any information that relates to an identified or identifiable individual.",
      },
      { term: "Service", definition: "refers to the Application." },
      {
        term: "Service Provider",
        definition:
          "means any natural or legal person who processes data on behalf of the Company.",
      },
      {
        term: "Usage Data",
        definition:
          "refers to data collected automatically, either generated by the use of the Service or from the Service infrastructure itself (for example, the duration of a page visit).",
      },
      {
        term: "You",
        definition:
          "refers to the individual accessing or using the Service, or the legal entity on behalf of which such individual is accessing or using the Service, as applicable.",
      },
    ],
  },
  {
    sectionTitle: "Licence to Use",
    content: `As long as you follow these Terms of Service, we grant you limited, non-exclusive, and revocable access to make personal, non-commercial use of the EduBridge Classroom Service and Content...`,
  },
  {
    sectionTitle: "Embankment Bridge Ltd's Proprietary Rights",
    content: `The EduBridge Classroom Service, Content, and intellectual property are owned by Embankment Bridge Ltd...`,
  },
  {
    sectionTitle: "Acceptable Uses",
    content: `You must access and use the Service only for legal, authorised, and acceptable purposes...`,
  },
  {
    sectionTitle: "Prohibited Behaviours and Account Suspension",
    content: `You agree to use the Application according to these Terms and applicable laws and regulations...`,
  },
  {
    sectionTitle: "User-Generated Content",
    content: `Users can create, complete, and download quizzes through the Service. The company reserves the right to use or remove quizzes at our discretion.`,
  },
  {
    sectionTitle: "Payments and Cancellations",
    content: `You can purchase your subscription directly from EduBridge Classroom by paying monthly or pre-paying for a fixed term...`,
  },
  {
    sectionTitle: "Privacy Policy Information",
    content: `Your privacy is important to us. Please see our Privacy Policy for more information on how we collect and keep your data safe.`,
  },
  {
    sectionTitle: "Limitation of Liability",
    content: `To the maximum extent permitted by law, Embankment Bridge Ltd will not be liable for any indirect, incidental, special, punitive, or consequential damages...`,
  },
  {
    sectionTitle: "Disclaimers and Warranties",
    content: `The Application and Service are provided ‘as is’ without any warranty or condition of any kind, either express or implied...`,
  },
  {
    sectionTitle: "Governing Laws",
    content: `These terms and conditions are governed by and construed in accordance with the laws of England and Wales...`,
  },
  {
    sectionTitle: "Changes to Your Terms",
    content: `We will use all reasonable efforts to ensure the EduBridge Classroom Service is operational and provides you with a personalised experience...`,
  },
  {
    sectionTitle: "Contact Information",
    content: `By email: support@edubridge.org.ok\nBy visiting this page on our website: https://edubridge.org.uk/contact-us`,
  },
];

function Terms() {
  let navigate = useNavigate();
  let navigateBack = () => {
    navigate(-1);
  };
  return (
    <section className="Privacy">
      <div className="container">
        <button className="div-save-bt" onClick={navigateBack}>
          <IoMdArrowBack /> &nbsp;Back
        </button>
        <div className="row">
          <div className="col-lg-12">
            <div className="privasy-content">
              <header>
                <p className="privasy-p1">{termsData[0].title}</p>
                <p className="privasy-p2">
                  Last updated: {termsData[0].lastUpdated}
                </p>
              </header>
              {termsData.slice(1).map((section, index) => (
                <section key={index} className="privasy-p3">
                  <h4>{section.sectionTitle}</h4>
                  <p>{section.content}</p>
                  {section.definitions && (
                    <ul className="ullist">
                      {section.definitions.map((definition, defIndex) => (
                        <li key={defIndex}>
                          <strong>{definition.term}:</strong>{" "}
                          {definition.definition}
                        </li>
                      ))}
                    </ul>
                  )}
                </section>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Terms;
